export const MemberData=[
    {
    
        name:"Anurag Singh",
        position:"Team Leader",
      imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/WhatsApp%20Image%202022-08-25%20at%2012.41.23%20PM.jpeg?alt=media&token=c48c3328-ccfc-46df-a3a7-eae554a6ae8e",
    },
    {
    
        name:"Mukesh Bagaria",
        position:"Team Member",
        imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/MUKESH.jpg?alt=media&token=2ab1636b-8587-4503-86e0-6befb9b698b8",

    
    },
    {
    
        name:"Mithu Gupta",
        position:"Team Member",
        imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/WhatsApp%20Image%202022-08-25%20at%2012.41.36%20PM.jpeg?alt=media&token=671fff8f-ce88-4220-9db8-e8515456f0c7",

    
    },
    {
    
        name:"Ayush Saxena",
        position:"Team Member",
        imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/Ayush%20Picture%202.jpg?alt=media&token=35f4102d-5beb-4a28-aa73-664aa7505526",

    
    },
    {
    
        name:"Pushpanjali",
        position:"Team Member",
        imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/WhatsApp%20Image%202022-08-25%20at%2012.41.49%20PM.jpeg?alt=media&token=8e62f1a8-56f4-4232-bc40-615934c348f1",

    
    },
    {
    
        name:"Swajeet Swarnkar",
        position:"Team Member",
        imgLink:"https://firebasestorage.googleapis.com/v0/b/sih-2022-38cd9.appspot.com/o/WhatsApp%20Image%202022-08-25%20at%2012.42.01%20PM.jpeg?alt=media&token=088a43a3-656a-44cf-ab10-d0fdeaaf21d8",

    
    },
    
]
